<template>
  <Layout title="Reset Your Password">
    <ForgotForm v-on:form-submitted="submitData" />
    <PageLoading v-if="loading" />
  </Layout>
</template>

<script>
import ForgotForm from "@/components/Forms/ForgotForm.vue";
import Layout from "@/Layout/NotAuthenticated/Layout.vue";

export default {
  name: "ResetPassword",
  data() {
    return {
      user: null,
      loading: false,
    };
  },
  components: {
    Layout,
    ForgotForm,
  },
  methods: {
    submitData(user) {
      this.loading = true;
      this.user = user;
      this.$store
        .dispatch("rememberPassword", this.user)
        .then((r) => {
          this.loading = false;
          this.$toasted.global.notificate({
            message: r.data.message,
            type: "success",
          });
        })
        .catch((error) => {
          this.loading = false;
          this.$toasted.global.notificate({
            message: error.response.data.message,
            type: "error",
          });
        });
    },
  },
};
</script>
